import { ActiveUnit } from './active-unit';

export enum BillableEventType {
  LIFT_OFF = 'LIFT_OFF',
  LIFT_ON = 'LIFT_ON',
  DIG = 'DIG',
  OTHER = 'OTHER',
  CREDIT = 'CREDIT'
}

export type BillableEvent = {
  id: number;
  type: BillableEventType;
  unit?: ActiveUnit;
  unitNumber: string;
  /** Date string */
  timestamp: string;
  label?: string;
  cost: number;
  operator?: string;
  associatedUnit?: ActiveUnit;
};

export const defaultBillableEvent = (): BillableEvent => ({
  id: 0,
  cost: 0,
  label: '',
  operator: '',
  timestamp: new Date().toISOString(),
  type: BillableEventType.LIFT_OFF,
  unit: undefined,
  unitNumber: ''
});
